/**
 * Returns true if the provided timestamp is for a date in the future.
 * @param timestamp
 * @returns boolean
 */
export const isDateInTheFuture = (timestamp: string) => {
    return new Date(timestamp) >= new Date();
};
